import {Component, OnInit} from '@angular/core';
import {NeoACLService} from "../../../core/services/neo-acl/neo-acl";


@Component({

  selector: 'sa-navigation',
  templateUrl: './navigation.component.html'
})
export class NavigationComponent implements OnInit {

  constructor(public acl: NeoACLService) {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/layout/navigation/navigation.component.ts